import React, { useEffect } from 'react'
import {
  Image,
  withSitecoreContext,
  RichText,
  Link,
  isEditorActive,
} from '@sitecore-jss/sitecore-jss-react'
import { ComponentProps } from '../../types/types'

import './index.scss'
import { TextModuleModel } from './models/TextModule.model'
import { anchorWithId } from '../../helpers/anchorWithId.helper'

interface TextModuleProps extends ComponentProps {}

const TextModule = (props: TextModuleProps) => {
  const model = new TextModuleModel(props)
  const isEE = props.sitecoreContext?.pageEditing;

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <>
      {props.fields && (
        <div
          className={
            model.AlignToAccordion.value
              ? 'TextModule__align_container'
              : 'TextModule__container'
          }
        >
          <div
            id={props?.rendering?.uid}
            className={
              model.link1?.href || model.link2?.href
                ? model.variant?.value === 'v2'
                  ? `text-module withcta text-module--${model.textPosition?.value} txtMdlB`
                  : model.title?.value?.length === 0
                  ? `text-module withcta text-module--${model.textPosition?.value} txtMdlA txtMdlAAA`
                  : `text-module withcta text-module--${model.textPosition?.value} txtMdlA`
                : model.variant?.value === 'v2'
                ? `text-module text-module--${model.textPosition?.value} txtMdlB`
                : model.title?.value?.length === 0
                ? `text-module text-module--${model.textPosition?.value} txtMdlA txtMdlAAA`
                : `text-module text-module--${model.textPosition?.value} txtMdlA`
            }
            style={
              model.variant?.value !== 'v2' && props.params?.Larger !== 0
                ? { maxWidth: '1147px', width: '100%' }
                : {}
            }
          >
            <div
              className={`text-module__content text-module__content--${model.textPosition?.value} `}
              style={{ fontWeight: 500 }}
            >
              {(model.eyebrow?.value ?? '')?.length > 0 && (
                <RichText
                  tag="div"
                  field={model.eyebrow}
                  className={'text-module__eyebrow'}
                />
              )}

              {(model.image?.value?.src ?? '')?.length > 0 && (
                <Image
                  field={model.image}
                  className={
                    (isEditorActive() || isEE) &&
                    (model.image?.value?.src ?? '').indexOf(
                      'shell/Themes/Standard/Images'
                    )
                      ? 'text-module__icon--desktop imageEE'
                      : 'text-module__icon--desktop'
                  }
                />
              )}

              {(model.imageMobile?.value?.src ?? '')?.length > 0 && (
                <Image
                  field={
                    (model.imageMobile &&
                    Object.keys(model.imageMobile?.value ?? []).length > 0)
                      ? model.imageMobile
                      : (model?.AllowFallbackForMobile ? model.image : undefined)
                  }
                  className={
                    (isEditorActive() || isEE) &&
                    (model.image?.value?.src ?? '').indexOf(
                      'shell/Themes/Standard/Images'
                    )
                      ? 'text-module__icon--mobile imageEE'
                      : 'text-module__icon--mobile'
                  }
                  alt="Mobile"
                />
              )}

              {(model.title?.value ?? '')?.length > 0 &&
                (model.variant?.value === 'v1' ? (
                  <RichText
                    tag="h3"
                    field={model.title}
                    className={'text-module__title text-module__ttlB'}
                  />
                ) : model.variant?.value === 'v2' ? (
                  <RichText
                    tag="h3"
                    field={model.title}
                    className={'text-module__title text-module__ttlA'}
                  />
                ) : model.variant?.value === 'v3' ? (
                  <RichText
                    tag="h3"
                    field={model.title}
                    className={
                      'text-module__title text-module__ttlB text-module__ttlAE'
                    }
                  />
                ) : model.variant?.value === 'v4' ? (
                  <RichText
                    tag="h3"
                    field={model.title}
                    className={'text-module__title text-module__ttlAEF'}
                  />
                ) : (
                  <></>
                ))}

              {(model.abstract?.value ?? '')?.length > 0 && (
                <RichText
                  tag="div"
                  field={model.abstract}
                  className={'text-module__abstract'}
                />
              )}

              {(model.subtitle?.value ?? '')?.length > 0 &&
                (model.variant?.value === 'v2' ? (
                  <RichText
                    tag="div"
                    field={model.subtitle}
                    className={'text-module__subtitle text-module__subtA'}
                  />
                ) : (
                  <RichText
                    tag="div"
                    field={model.subtitle}
                    className={'text-module__subtitle text-module__subtB'}
                  />
                ))}

              {(model.bodyText?.value ?? '')?.length > 0 && (
                <RichText
                  tag="div"
                  field={model.bodyText}
                  className={
                    props.params?.textSize === 'small'
                      ? `text-module__text small`
                      : `text-module__text`
                  }
                />
              )}

              {(model.link1?.href || model.link2?.href) && (
                <div className={'text-module__buttons'}>
                  {(isEE || model.link1?.text || model.link1?.href) && (
                    <div className="cta cta-primary-red">
                      {isEE ? (
                        <Link field={model.link1} />
                      ) : (
                        <Link field={model.link1} />
                      )}
                    </div>
                  )}
                  {(isEE || model.link2?.text || model.link2?.href) && (
                    <div
                      className={
                        model.link1?.href
                          ? `secondary-link secondary-link-blue`
                          : `secondary-link secondary-link-blue ml-0`
                      }
                    >
                      <a
                        href={anchorWithId(
                          model.link2?.href ?? '',
                          model.link2?.anchor
                        )}
                        title={model.link2?.title}
                        target={model.link2?.target}
                      >
                        {model.link2?.text}
                        <span className="link-with-arrow link-with-arrow--text">
                          <pfe-icon
                            icon="cnh-arrow-forward"
                            size={'24'}
                            color={'complement'}
                          />
                        </span>
                      </a>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default withSitecoreContext()(TextModule)
